import { createApp } from 'vue'
import App from './App.vue'

import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import VueViewer from 'v-viewer'
import NormalTable from "@/zhivue/components/table/NormalTable.vue";

import ApiService from "@/core/services/ApiService";
import "bootstrap";
import VueLazyload from 'vue-lazyload'
import InlineSvg from "vue-inline-svg";

const app = createApp(App);
app.component('normal-table',NormalTable);
app.use(store);
app.use(router);
app.use(ElementPlus,{
    locale: zhCn
});
app.use(VueViewer);
app.use(VueLazyload)

ApiService.init(app);
app.component("inline-svg", InlineSvg);

window.vueApp = app;
app.mount('#app');
